module.exports = __webpack_public_path__ + "public/img/xm20190118_04.f40df59e.png";